export default class solutionManager {
    constructor(effect, param) {

        this.effect = effect;
        this.param = param;
        // this.$;
        this.$target;
        this.href = [];
        this.url;
        this.$contents;
        this.id = [];
        this.position;
        this.$header
        this.headerHeight;
        this.scrollY;

    }

    init() {
    }

    render(mouse, scrollInc) {
    }

    resize(w, h) {
    }

    scroll(e, inc) {
    }

    onNext(){
        alert();
    }

    onPrev(){}

}
